import React, { Component } from "react";
export default class About extends Component {
    render() {
        let resumeData = this.props.resumeData;
        const socialLinks = resumeData.socialLinks.filter(item=>{
            return (item.name === "linkedin" || item.name === "skype" || item.name === "facebook")
        })
        return <section id="about">
                <div className="row">
                    <div className="three columns" style={{ display: "flex", paddingBottom: "30px", justifyContent: "center" }}>
                        <img className="profile-pic" src="images/profilepic.jpg" alt="" />
                    </div>

                    <div className="nine columns main-col">
                        <h2>About Me</h2>
                        <p>{resumeData.aboutme}</p>

                        <div className="row">
                            <div className="columns contact-details">
                                <h2>Contact Details</h2>
                                <p className="address">
                                    <span>{resumeData.name}</span>
                                    <br />
                                    <span>{resumeData.address}</span>

                                    <br />
                                    <ul className="social" style={{ display: "flex", marginBottom: 0, fontSize: "22px" }}>
                                        {socialLinks && socialLinks.map(
                                            (item) => {
                                                return <li key={item.name} style={{ marginRight: "18px" }}>
                                                        <a href={item.url} target="_blank">
                                                            <i className={item.className} />
                                                        </a>
                                                    </li>;
                                            }
                                        )}
                                    </ul>
                                    <span>
                                        <a
                                            href={[
                                                "mailto:",
                                                resumeData.email,
                                            ].join("")}
                                        >
                                            {resumeData.email}
                                        </a>
                                    </span>
                                    <br />
                                    <span>
                                        <a href={resumeData.website}>
                                            {resumeData.website}
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>;
    }
}
